/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_card__review__fabulous = /** @type {(inputs: {}) => string} */ () => {
	return `Fabelhaft`
};

const en_poi_card__review__fabulous = /** @type {(inputs: {}) => string} */ () => {
	return `Fabulous`
};

const es_poi_card__review__fabulous = /** @type {(inputs: {}) => string} */ () => {
	return `Fantástico`
};

const fr_poi_card__review__fabulous = /** @type {(inputs: {}) => string} */ () => {
	return `Fabuleux`
};

const it_poi_card__review__fabulous = /** @type {(inputs: {}) => string} */ () => {
	return `Favoloso`
};

const nl_poi_card__review__fabulous = /** @type {(inputs: {}) => string} */ () => {
	return `Fantastisch`
};

const pt_poi_card__review__fabulous = /** @type {(inputs: {}) => string} */ () => {
	return `Fabuloso`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__fabulous = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_card__review__fabulous(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_card__review__fabulous", locale)
	if (locale === "de") return de_poi_card__review__fabulous(inputs)
	if (locale === "en") return en_poi_card__review__fabulous(inputs)
	if (locale === "es") return es_poi_card__review__fabulous(inputs)
	if (locale === "fr") return fr_poi_card__review__fabulous(inputs)
	if (locale === "it") return it_poi_card__review__fabulous(inputs)
	if (locale === "nl") return nl_poi_card__review__fabulous(inputs)
	return pt_poi_card__review__fabulous(inputs)
};